export default __webpack_public_path__ + "static/media/168.660cd85f.png";